import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
//Limitless imports
import { CompactKnowledgeBase, useHelpDrawer } from "../..";
const useStyles = makeStyles({
  drawer: {
    top: 64,
    width: 400,
    height: "calc(100vh - 64px)"
  }
});
const PortalHelp = () => {
  const {
    isDrawerOpen,
    toggleHelpDrawer
  } = useHelpDrawer();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: isDrawerOpen,
    onClose: toggleHelpDrawer,
    classes: {
      paperAnchorRight: classes.drawer
    },
    variant: "persistent"
  }, /*#__PURE__*/React.createElement(Grid, {
    sx: {
      marginBottom: "80px"
    }
  }, isDrawerOpen && /*#__PURE__*/React.createElement(CompactKnowledgeBase, {
    isKnowledgeActive: true,
    showClose: true
  })));
};
export default PortalHelp;
PortalHelp.propTypes = {
  children: PropTypes.node
};